import React from 'react';
import PropTypes from 'prop-types';
import { FaqElement } from './FaqElement';

export const Faq = ({ faqs }) => (
  <section className="section">
    <div className="container">
      <h1 className="text-center mb-20px">Frequently asked questions</h1>
      <div className="faq">
        {faqs.map(({ question, answer }) => (
          <FaqElement key={question} question={question} answer={answer} />
        ))}
      </div>
    </div>
  </section>
);

Faq.propTypes = {
  faqs: PropTypes.arrayOf(
    PropTypes.shape({
      question: PropTypes.string.isRequired,
      answer: PropTypes.string.isRequired,
    })
  ).isRequired,
};
